import React from 'react';
import { Question, Team } from '../Game/Game';
import Button from '../../components/Button';
import NumberEditor from '../../components/NumberEditor';
import FinalJeopardyWagers from './FinalJeopardyWagers';
import { Row } from '../../components/RowCol';
import Spacer from '../../components/Spacer';

type Props = {
	finalJeopardy: boolean;
	finalJeopardyWagers: [number, number] | null;
	setFinalJeopardyWagers: (wagers: [number, number]) => void;
	question: Question;
	dailyDoubleWager: number | null;
	setDailyDoubleWager: (wager: number) => void;
	questionLevel?: number;
	resolveQuestion: (winningTeam: Team | null) => void;
	resolveDailyDouble: (team: Team, points: number) => void;
	resolveFinalJeopardy: (team: Team, points: number) => void;
}

const QuestionControls: React.FC<Props> = ({
	finalJeopardy,
	finalJeopardyWagers,
	setFinalJeopardyWagers,
	question,
	dailyDoubleWager,
	setDailyDoubleWager,
	questionLevel,
	resolveQuestion,
	resolveDailyDouble,
	resolveFinalJeopardy,
}) => {
	if (finalJeopardy) {
		if (finalJeopardyWagers == null) {
			return (
				<FinalJeopardyWagers
					wagers={finalJeopardyWagers}
					setWagers={setFinalJeopardyWagers}
				/>
			);
		}
		return (
			<>
				<Row alignCenter>
					<div style={{
						fontFamily: 'Korinna',
						textTransform: 'uppercase',
						fontSize: '48px',
						color: 'white',
					}}>
						Team A: ${finalJeopardyWagers[0]}
					</div>
					<Spacer horizontal={50} />
					<Button
						label="Correct"
						onClick={() => resolveFinalJeopardy('A', finalJeopardyWagers[0])}
					/>
					<Spacer horizontal={10} />
					<Button
						label="Incorrect"
						onClick={() => resolveFinalJeopardy('A', -finalJeopardyWagers[0])}
					/>
				</Row>

				<Spacer vertical={50} />

				<Row alignCenter>
					<div style={{
						fontFamily: 'Korinna',
						textTransform: 'uppercase',
						fontSize: '48px',
						color: 'white',
					}}>
						Team B: ${finalJeopardyWagers[1]}
					</div>
					<Spacer horizontal={50} />
					<Button
						label="Correct"
						onClick={() => resolveFinalJeopardy('B', finalJeopardyWagers[1])}
					/>
					<Spacer horizontal={10} />
					<Button
						label="Incorrect"
						onClick={() => resolveFinalJeopardy('B', -finalJeopardyWagers[1])}
					/>
				</Row>
			</>
		);
	}

	if (question.dailyDouble) {
		if (dailyDoubleWager === null) {
			return (
				<NumberEditor
					label="Set Daily Double Wager:"
					number={0}
					edit={setDailyDoubleWager}
				/>
			);
		}
		return (
			<>
				<div style={{
					fontFamily: 'Korinna',
					textTransform: 'uppercase',
					fontSize: '48px',
					color: 'white',
				}}>
					${dailyDoubleWager}
				</div>

				<Button
					label="+A"
					onClick={() => resolveDailyDouble('A', dailyDoubleWager)}
				/>
				<Button
					label="−A"
					onClick={() => resolveDailyDouble('A', -dailyDoubleWager)}
				/>
				<Button
					label="+B"
					onClick={() => resolveDailyDouble('B', dailyDoubleWager)}
				/>
				<Button
					label="−B"
					onClick={() => resolveDailyDouble('B', -dailyDoubleWager)}
				/>
			</>
		);
	}

	return (
		<>
			{questionLevel && (
				<div style={{
					fontFamily: 'Korinna',
					textTransform: 'uppercase',
					fontSize: '48px',
					color: 'white',
				}}>
					${questionLevel}
				</div>
			)}
			<Button
				label="Team A"
				onClick={() => resolveQuestion('A')}
			/>
			<Button
				label="Team B"
				onClick={() => resolveQuestion('B')}
			/>
			<Button
				label="No Score"
				onClick={() => resolveQuestion(null)}
			/>
		</>
	);
};

export default QuestionControls;
